// import log from 'salvo-lite/log'
import ScrollReveal from 'scrollreveal'

class Reveal {
    constructor (theme, elem) {
        this.elem = elem
        this.options = Object.assign({
            delay: 0,
            duration: 500,
            reset: false
        }, JSON.parse(this.elem.dataset.scrollReveal ? this.elem.dataset.scrollReveal : '{}'))
    // log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
    // log.debug(this.constructor.name, 'Initiating', this)
        ScrollReveal().reveal(this.elem, this.options)

        document.addEventListener('updateScrollReveal', () => {
            ScrollReveal().sync()
        })

    // log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default Reveal



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Reveal.js